import React from 'react';
import AccordionItem from './AccordionItem';
import { graphql, useStaticQuery } from 'gatsby';

const Accordians = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        faq {
          id
          question
          answer
        }
      }
    }
  `);

  const {
    strapiHomePage: { faq },
  } = data;

  return (
    <div className='accrodion-grp faq-accrodion'>
      {faq.map((node, index) => {
        var status;
        index === 0 ? (status = true) : (status = false);
        return (
          <AccordionItem
            key={node.id}
            title={node.question}
            content={node.answer}
            status={status}
            project={node.question}
          />
        );
      })}
    </div>
  );
};

export default Accordians;
